import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { api } from "../api";

/** /daily -- redirects to today's pin. Rolls over at 00:00 UTC. */
export function Daily() {
  const [pinId, setPinId] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .daily()
      .then((d) => setPinId(d.pinId))
      .catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div className="page">
        <h1>No daily pin today.</h1>
        <p style={{ color: "var(--muted)" }}>Try again in a moment.</p>
      </div>
    );
  }
  if (!pinId) {
    return <div className="page" style={{ color: "var(--muted)" }}>Loading today's pin…</div>;
  }
  return <Navigate to={`/p/${pinId}`} replace />;
}
